import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import Hero from './components/Hero';
import Features from './components/Features';
import Categories from './components/Categories';
import HotArticles from './components/HotArticles';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

export default function Home() {
  useEffect(() => {
    document.title = 'JavBus – 官方入口与完整使用指南 | 影片资料库平台';
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', 'JavBus 是广受用户关注的影片资料库平台，本页为您提供 JavBus 的最新访问入口、功能介绍、搜索技巧及常见问题解答，帮助您快速找到所需内容，畅享完整的 JavBus 使用体验。');
    }
  }, []);

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'JavBus 使用指南',
    url: 'https://javbus-guide.com/',
    description: 'JavBus 影片资料库平台使用指南，提供最新访问入口、搜索技巧及常见问题解答。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://javbus-guide.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <ScrollToTop />
      <Navbar />
      <main>
        <Hero />
        <Features />
        <Categories />
        <HotArticles />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}